import { Slider } from "artisn-ui-react";
import React from "react";

import CategorySliderPlaceholder from "./CategorySlider.placeholder";
import Styles from "./CategorySlider.styles";
import { CategorySliderProps as Props } from "./CategorySlider.types";
import CONSTANTS from "config/constants";
import useAuth from "contexts/auth/auth.context.hooks";
import useWindowSize from "hooks/useWindowSize";

const { BREAKPOINTS } = CONSTANTS;
const { tablet } = BREAKPOINTS;

const CategorySlider: React.FC<Props> = props => {
  const { children, title, height, className, isLoading, ...rest } = props;
  const { width } = useWindowSize();
  const isMobile = width <= tablet;
  const { isAnonymous } = useAuth();
  const titleStyles = isAnonymous ? "CategorySlider__title--white" : "";

  return (
    <Styles className={`CategorySlider ${className}`}>
      {!isLoading ? (
        <>
          <h2 className={`CategorySlider__title ${titleStyles}`}>{title}</h2>
          <Slider
            slideWidth={isMobile ? 168 : 364}
            height={height}
            gap={24}
            infinite
            {...rest}
          >
            {children}
          </Slider>
        </>
      ) : (
        <CategorySliderPlaceholder />
      )}
    </Styles>
  );
};

CategorySlider.defaultProps = {
  className: ""
};

export default CategorySlider;
